import { Injectable, inject } from '@angular/core';
import { OrganizationRoleType } from 'shared-states';
import { NavigationTarget } from '../../navigation-target';
import { LegacyRoutes } from '../../portal-routes';
import { PortalUrls } from '../../portal-urls.service';
import { LandingContext, LandingRule } from '../landing-rule';

/** A user with at least one supplier organization lands on the Legacy dashboard (all regions). */
@Injectable({ providedIn: 'root' })
export class SupplierDashboardLandingRule implements LandingRule {
  private readonly urls = inject(PortalUrls);

  resolve({ organizations }: LandingContext): NavigationTarget | null {
    return organizations.some(organization => organization.role === OrganizationRoleType.supplier)
      ? NavigationTarget.external(this.urls.legacyPortal(LegacyRoutes.dashboard))
      : null;
  }
}
